import { addDoc, collection } from "@firebase/firestore";
import { db } from "../../../firebase";
import HelperForMetaData from "../../../Helpers/HelperForMetaData";

const CreateExam = async (ExamObject, uid) => {
  try {
    const ExamsCollection = await collection(db, "Exams");

    const data = HelperForMetaData({
      ...ExamObject,
      uid: uid,
    });
    await addDoc(ExamsCollection, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default CreateExam;
